import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TodosCompComponent } from './components/todos-comp/todos-comp.component';
import { AboutComponent } from './components/pages/about/about.component';

const routes: Routes = [
  { path: 'about', component: AboutComponent },
  { path: '', component: TodosCompComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
